module.exports = __webpack_public_path__ + "img/img5.db150f22.png";